module.exports = __webpack_public_path__ + "img/IMG_7364.b96b762a.jpg";